export const CSRF_COOKIE = 'csrf_token';
export const CSRF_HEADER = 'x-csrf-token';

/**
 * Reads the double-submit CSRF token the API set.
 *
 * This cookie is deliberately *not* httpOnly — the client has to be able to
 * read it and echo it back in a header, which is exactly what proves the
 * request came from our own JavaScript rather than a cross-site form post.
 */
export function readCsrfToken(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  for (const part of document.cookie.split(';')) {
    const separator = part.indexOf('=');
    if (separator === -1) continue;

    if (part.slice(0, separator).trim() === CSRF_COOKIE) {
      return decodeURIComponent(part.slice(separator + 1));
    }
  }

  return undefined;
}
